<template>
    <div>
        <div style="margin-top: 2rem; padding-bottom: 2rem;">
            
            <!-- Upcoming !-->
            <stream-item-base class="text-center" line-type="none">
                <span class="badge badge-secondary" style="font-size: .95rem; width: 100px;">Planned</span>
                <div v-if="!hasPlannedItems">
                    <p style="font-size: 1.2rem; margin-top: 2rem; margin-bottom: 0;">There is nothing planned</p>
                    <a href="#" @click.prevent="$emit('schedule')" style="font-weight: bold;">+ Schedule an activity</a>
                </div>
            </stream-item-base>

            <component 
                v-for="item in plannedItems" 
                :key="item.stream_id" 
                :is="item.component" 
                :data="item"
                @updated="e => { loadStream(e); $emit('updated') }"
                @deleted="e => { loadStream(e); $emit('updated') }"
            />

            <!-- Past !-->
            <stream-item-base class="text-center" :line-type="hasPlannedItems && hasDoneItems ? 'dashed' : 'none'">
                <span class="badge badge-secondary" style="font-size: .95rem; margin-top: 3rem; width: 100px;">History</span>
                <p v-if="!hasDoneItems" style="font-size: 1.2rem; margin-top: 2rem; margin-bottom: 1rem;">Nothing has been completed</p>
            </stream-item-base>

            <component 
                v-for="item in doneItems" 
                :key="item.stream_id" 
                :is="item.component" 
                :data="item"
                @updated="e => { loadStream(e); $emit('updated') }"
                @deleted="e => { loadStream(e); $emit('updated') }"
            />


        </div>
    </div>
</template>

<script>
    import StreamItemBase from '../../elements/stream/StreamItemBase'
    import NoteStreamItem from '../../elements/stream/NoteStreamItem'
    import ActivityStreamItem from '../../elements/stream/ActivityStreamItem'
    import DealStreamItem from "./DealStreamItem";
    import BookingStreamItem from "./BookingStreamItem";
    import Moment from 'moment'
    import MessageStreamItem from "./MessageStreamItem";
    import ReservationStreamItem from "./ReservationStreamItem.vue";
    import ArchivedDealStreamItem from "./ArchivedDealStreamItem.vue";
    import OfferStreamItem from "./OfferStreamItem.vue";

    export default {
        components: {
            StreamItemBase,
            NoteStreamItem,
            ActivityStreamItem,
            DealStreamItem,
            BookingStreamItem,
            MessageStreamItem,
            ReservationStreamItem,
            ArchivedDealStreamItem,
            OfferStreamItem,
        },
        props: {
            streamRetriever: {
                type: Function,
                required: true,
            }
        },
        data() {
            return {
                stream: []
            }
        },
        mounted() {
            this.loadStream()
        },
        methods: {
            loadStream() {
                this.streamRetriever().then(stream => {
                    this.stream = stream
                })
            }
        },
        computed: {
            streamWithComponents() {
                return _.filter(
                    this.stream.map(item => {
                        switch (item.stream_type) {
                            case 'activity':
                                item.component = ActivityStreamItem
                                break;
                            case 'note':
                                item.component = NoteStreamItem
                                break;
                            case 'offer':
                                item.component = OfferStreamItem
                                break;
                            case 'deal':
                                item.component = DealStreamItem
                                break;
                            case 'archived_deal':
                                item.component = ArchivedDealStreamItem
                                break;
                            case 'booking':
                                item.component = BookingStreamItem
                                break;
                            case 'message':
                                item.component = MessageStreamItem
                                break;
                            case 'reservation':
                                item.component = ReservationStreamItem
                                break;
                            default:
                                item = null;
                        }

                        return item
                    })
                )
            },
            hasPlannedItems() {
                return this.plannedItems.length > 0
            },
            plannedItems() {
                return this.streamWithComponents.filter(item => {
                    return item.stream_type === 'activity' && !item.completed_at ||
                        Moment(item.stream_date).isAfter(Moment())
                })
            },
            hasDoneItems() {
                return this.doneItems.length > 0
            },
            doneItems() {
                return _.sortBy(this.streamWithComponents.filter(item => {
                    return (item.stream_type !== 'activity' || item.completed_at) && Moment(item.stream_date).isBefore(Moment())
                }), 'stream_date').reverse()
            }
        }
    }
</script>